export default __webpack_public_path__ + "static/media/prepare-exam-background-desktop.0798be16.svg";